import * as React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";
import { changeUrl } from "common/history";

const useStyles = makeStyles(() => ({
    aboutUsLabel: { transform: "none" },
}));

export default function AboutUsButton() {
    const styles = useStyles();
    return (
        <Button
            onClick={() => {
                changeUrl("/about-us");
            }}
            color="secondary"
            classes={{ label: styles.aboutUsLabel }}
            style={{ backgroundColor: Colors.panelLight, padding: "3px 4px", borderRadius: 7 }}
        >
            <img src="/images/LogoOnly.png" width="36" height="36" alt="" />
            <span style={{ lineHeight: 1, paddingRight: 4, paddingTop: 2, paddingLeft: 3 }}>About Us</span>
        </Button>
    );
}
